import { Envs } from '../envs.js';

const getAppHost = () => {
  return Envs.APP_HOST;
};
const getAppUrl = path => {
  return `${getAppHost()}${path}`;
};

export { getAppHost, getAppUrl };
